import { Referral as Api } from '@synapex/shared2/gateway-rest-api';

import * as ReplyParser from './reply-parser';
import { api } from '@/shared/api';

export const getMany = () =>
  api.get<Api.getMany.Reply>(Api.PREFIX).then(ReplyParser.referralManyReply);
